import axios, { AxiosError } from 'axios';

async function getUsuarios(filters: ApiFiltersType, token: string | null) {
  try {
    const response = await axios({
      headers: {
        Authorization: token,
      },
      method: 'get',
      url: `${process.env.REACT_APP_SERVICE_API}/rest/json/usuario/lista`,
      params: {
        ...filters,
      }
    });
    
    return { status: response.status, data: response.data }
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        return { status: axiosError.response.status, data: axiosError.message }
      }
      console.error(axiosError.message);
      return { status: axiosError.status ? axiosError.status : 500, data: axiosError.message }
    } else {
      return { status: 400, data: error }
    }
  }
}

async function getUsuario(token: string | null, usuCodigo: string) {
  try {
    const response = await axios({
      headers: {
        Authorization: token,
      },
      method: 'get',
      url: `${process.env.REACT_APP_SERVICE_API}/rest/json/usuario/${usuCodigo}`,
    });
    
    return { status: response.status, data: response.data }
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        return { status: axiosError.response.status, data: axiosError.message }
      }
      console.error(axiosError.message);
      return { status: axiosError.status ? axiosError.status : 500, data: axiosError.message }
    } else {
      return { status: 400, data: error }
    }
  }
}

async function updateUsuarioStatus(postBody: { usuMaster: boolean, usuCodigo: number | string}, token: string | null) {
  try {
    const response = await axios({
      headers: {
        Authorization: token,
      },
      method: 'put',
      url: `${process.env.REACT_APP_SERVICE_API}/rest/json/usuario/master`,
      data: postBody
    });

    return { status: response.status, data: response.data }
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        return { status: axiosError.response.status, data: axiosError.message }
      }
      console.error(axiosError.message);
      return { status: axiosError.status ? axiosError.status : 500, data: axiosError.message }
    } else {
      return { status: 400, data: error }
    }
  }
}

async function getPropriedadesVinculadas(token: string | null, usuCodigo: number | string) {
  try {
    const response = await axios({
      headers: {
        Authorization: token,
      },
      method: 'get',
      url: `${process.env.REACT_APP_SERVICE_API}/rest/json/usuario/${usuCodigo}/propriedades`,
    });
    
    return { status: response.status, data: response.data }
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        return { status: axiosError.response.status, data: axiosError.message }
      }
      console.error(axiosError.message);
      return { status: axiosError.status ? axiosError.status : 500, data: axiosError.message }
    } else {
      return { status: 400, data: error }
    }
  }
}

async function updateUsuarioPropriedades(postBody: Propriedade[], token: string | null, usuCodigo: string) {
  try {
    const response = await axios({
      headers: {
        Authorization: token,
      },
      method: 'post',
      url: `${process.env.REACT_APP_SERVICE_API}/rest/json/usuario/propriedades/${usuCodigo}`,
      data: postBody
    });

    return { status: response.status, data: response.data }
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        return { status: axiosError.response.status, data: axiosError.message }
      }
      console.error(axiosError.message);
      return { status: axiosError.status ? axiosError.status : 500, data: axiosError.message }
    } else {
      return { status: 400, data: error }
    }
  }
}

export { getUsuarios, getUsuario, updateUsuarioStatus, getPropriedadesVinculadas, updateUsuarioPropriedades };
